import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { Body, Button, Heading } from 'copilot-design-system';
import React from 'react';

import { CDN_BASE_URL } from 'src/constants/externalUrls';
import history from 'src/history';
import { TaskDetailInfo } from 'src/legacy/components/HomePage/OnboardingTasksSection/helper';
import { UrlUtils } from 'src/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3.5),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2.5, 3),
      },
    },
    descriptionWrapper: {
      marginTop: theme.spacing(0.25),
      minWidth: '250px',
      minHeight: '40px',
    },
    illustrationWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'end',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    actionButtonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '8px',
      marginTop: theme.spacing(2.75),
    },
  }),
);

interface TaskProps {
  taskData: TaskDetailInfo;
}

export const TaskDetails: React.FC<TaskProps> = ({ taskData }) => {
  const classes = useStyles();

  const handleLearnMoreAction = (actionLink: string) => {
    // determining action path type: external or internal
    // when action path external url (starts with http/s)
    if (UrlUtils.startsWithProtocol(actionLink)) {
      window.open(actionLink, '_blank');
      return;
    }

    // when action link is not an external link, navigate to it
    history.push(actionLink);
  };

  const { buttonLabel, routePath } = taskData;
  const isPrimaryButtonVisible =
    buttonLabel !== undefined && routePath !== undefined;

  return (
    <Grid container className={classes.root}>
      <Grid item xs>
        <Heading size="lg">{taskData.detailTitle ?? taskData.title}</Heading>
        <div className={classes.descriptionWrapper}>
          <Body size="sm" className="text-secondary leading-[21px]">
            {taskData.description}
          </Body>
        </div>
        <div className={classes.actionButtonContainer}>
          {isPrimaryButtonVisible && (
            <Button
              variant="secondary"
              label={buttonLabel}
              onClick={() => history.push(routePath)}
            />
          )}
          <Button
            variant={isPrimaryButtonVisible ? 'text' : 'secondary'}
            label="Learn more"
            onClick={() => handleLearnMoreAction(taskData.learnMoreLink)}
          />
        </div>
      </Grid>
      <Grid className={classes.illustrationWrapper} item xs>
        <img
          className="max-w-full max-h-[160px] mx-6 md:mr-0"
          src={
            CDN_BASE_URL +
            `/images/ftux/onboarding-tasks/${taskData.illustrationName}.svg`
          }
          alt={taskData.title}
        />
      </Grid>
    </Grid>
  );
};
